export default "__VITE_ASSET__C_116wkD__"